import React, { PropsWithChildren } from "react";
import classNames from "classnames";
import styles from "./FooterGrid.module.scss";
import { LayoutTypes } from "@/util-react/layout";

export interface FooterGridProps extends PropsWithChildren {
  layout: LayoutTypes.TYPE_DESKTOP | LayoutTypes.TYPE_MOBILE;
}

export const FooterGrid: React.FC<FooterGridProps> = ({ layout, children }) => {
  return (
    <div className={styles.footerGrid} data-layout={layout}>
      {React.Children.map(children, (child) => {
        // @ts-ignore
        return child?.props?.slot === "top" ? child : null;
      })}

      <div className={classNames(styles.divider, styles.spacing)} />

      <div className={styles.bottom}>
        {React.Children.map(children, (child) => {
          // @ts-ignore
          const slot = child?.props?.slot;
          if (
            [
              "main", // side with company logo and description
              "service", // user useful links
              "information", // about pages
              "contacts", // primary contacts
              "contactsAdditional", // additional contacts
            ].includes(slot)
          ) {
            return child;
          }
          return null;
        })}
      </div>
    </div>
  );
};
